export default __webpack_public_path__ + "static/media/icon-login-email-2.3f319e2c.webp";